import React, { useEffect, useState } from 'react';
import { ISimpleTextPageContent } from '../MobileAppTypes';
import { IScreenEditorProps } from './SharedTypes';

interface ISimpleTextPageEditorProps extends IScreenEditorProps {
  content: ISimpleTextPageContent;
}

const SimpleTextPageEditor: React.FC<ISimpleTextPageEditorProps> = ({
  content,
  errors,
  onContentChange,
  onFilesChange,
  onValidationChange
}) => {
  const [localContent, setLocalContent] = useState<ISimpleTextPageContent>(content);

  useEffect(() => {
    setLocalContent(content);
  }, [content]);

  const updateContent = (updates: Partial<ISimpleTextPageContent>) => {
    const newContent = { ...localContent, ...updates };
    setLocalContent(newContent);
    onContentChange(newContent);
    
    // Validate on change
    const validationErrors = validate(newContent);
    onValidationChange(validationErrors);
  };

  const validate = (contentToValidate: ISimpleTextPageContent = localContent): string[] => {
    const errors: string[] = [];
    if (!contentToValidate.title) errors.push('Page title is required');
    if (!contentToValidate.content) errors.push('Content is required');
    return errors;
  };

  return (
    <div className="form-section">
      <h4>Simple Text Page Content</h4>
      <div className="form-horizontal">
        <div className="form-group">
          <label className="col-sm-3 control-label">Page Title*</label>
          <div className="col-sm-9">
            <input 
              type="text" 
              className="form-control" 
              value={localContent.title} 
              onChange={(e) => updateContent({ title: e.target.value })} 
              placeholder="Page title" 
            />
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-3 control-label">Text Alignment</label>
          <div className="col-sm-9">
            <select 
              className="form-control" 
              value={localContent.textAlign} 
              onChange={(e) => updateContent({ 
                textAlign: e.target.value as 'left' | 'center' | 'right' | 'justify' 
              })}
            >
              <option value="left">Left</option>
              <option value="center">Center</option>
              <option value="right">Right</option>
              <option value="justify">Justify</option>
            </select>
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-3 control-label">Content</label>
          <div className="col-sm-9">
            <textarea 
              className="form-control" 
              rows={10} 
              value={localContent.content} 
              onChange={(e) => updateContent({ content: e.target.value })} 
              placeholder="Enter your text content here..." 
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimpleTextPageEditor;